module.exports = __webpack_public_path__ + "static/army-3f44abae632061357a43b4a06d9f91b2.jpg";